(function($) {
    $(window).on('load', function() {
        $('#home-brands .home-brands__list .swiper').each(function() {
            new Swiper(this, {
                slidesPerView: 5,
                spaceBetween: 15,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    0: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                    576: {
                        slidesPerView: 5,
                        spaceBetween: 15,
                    },
                    768: {
                        slidesPerView: 6,
                        spaceBetween: 15,
                    },
                    992: {
                        slidesPerView: 8,
                        spaceBetween: 15,
                    },
                }
            })
        })
    });
})(jQuery)